import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Space,
} from '@tonic-one/react';

import LoadingBtn from '../LoadingBtn';
import { useTranslation } from 'react-i18next';

interface ActionModalProps {
  disabled?: boolean;
  isOpen: boolean;
  title?: string;
  body: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
  size?: ModalProps['size'];
}

/**
 * @description Modal with async action
 */
export default function ActionModal(props: ActionModalProps) {
  const { t } = useTranslation('common');
  const {
    disabled = false,
    isOpen,
    title = '',
    body,
    confirmText = t('common.button.ok'), // default value
    cancelText = t('common.button.cancel'), // default value
    onConfirm,
    onClose,
    size = 'sm',
  } = props;

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={isOpen}
      onClose={onClose}
      size={size}
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalFooter>
          <LoadingBtn
            variant="primary"
            minWidth="20x"
            onClick={onConfirm}
            disabled={disabled}
          >
            {confirmText}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {cancelText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
